import { PropsWithChildren } from "react";

import { MoodysThemeProvider } from "@moodys/federated";
import { AustralianModal } from "components/AustralianModal/components/AustralianModal";
import { useLayoutContext } from "components/Layout/context";
import { LiveChatHiddenControl } from "components/LiveChat/LiveChatHiddenControl";
import { useGlobalSetup } from "hooks/useGlobalSetup";
import { generateSiteRebrandThemeOverrides } from "theme";

import { Favicon } from "./components/Favicon";
import { HeaderWithTheme } from "./components/HeaderWithTheme";
import { useHeaderContext } from "./context";

export const Header = ({ ...props }: PropsWithChildren) => {
  const { isLegacy } = useHeaderContext();
  useGlobalSetup(isLegacy);
  const { themeMode } = useLayoutContext();

  const themeOverrides = generateSiteRebrandThemeOverrides({
    themeMode,
  });

  return (
    <MoodysThemeProvider
      colorPalette={themeMode === "dark" ? "mdcBlue" : "default"}
      themeOverrides={themeOverrides}
    >
      <AustralianModal />
      <HeaderWithTheme {...props} />
      <Favicon />
      <LiveChatHiddenControl />
    </MoodysThemeProvider>
  );
};
